import { useContext } from 'react';
import { useRouter } from 'next/router';
import { appAuthContext } from 'context/AuthContext';
import getUser from 'api/requests/getUser';

const SetUserAfterReg = async () => {
  const { setUser } = useContext(appAuthContext);
  const router = useRouter();
  const data = await getUser();
  if (data) {
    setUser({ ...data });
    await router.replace(router.asPath);
  }
};

export default SetUserAfterReg;
